export default "__VITE_ASSET__DduFzKC2__"